import axios from "axios";

export const getDropdownUnitUsaha = async () => {
  return await axios.get(`${window._HOST}akuntan/unitUsaha/dropdown`, {
    withCredentials: true,
  });
};
